import {
    Directive,
    ElementRef,
    inject,
    inputBinding,
    input,
    OnInit,
    Renderer2,
    ViewContainerRef,
} from '@angular/core';
import {StepFocusRingDirective} from '../step-focus/step-focus-ring.directive';
import {StepHeadingComponent} from './step-heading.component';
import {STEP_LABELS} from './step-labels.model';

@Directive({
    standalone: true,
    host: {class: 'card mb-4 p-4'},
    hostDirectives: [StepFocusRingDirective],
})
export class StepCardDirective implements OnInit {
    private readonly labels = inject(STEP_LABELS);

    private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
    private readonly renderer = inject(Renderer2);
    private readonly viewContainerRef = inject(ViewContainerRef);

    readonly titleKey = input(this.labels.titleKey);
    readonly hintKey = input(this.labels.hintKey);

    ngOnInit(): void {
        const chrome = this.viewContainerRef.createComponent(StepHeadingComponent, {
            bindings: [
                inputBinding('titleKey', this.titleKey),
                inputBinding('hintKey', this.hintKey),
            ],
        });
        const host = this.elementRef.nativeElement;
        this.renderer.insertBefore(host, chrome.location.nativeElement, host.firstChild);
    }
}
